module.exports = __webpack_public_path__ + "img/st-dealer.7200682c.jpg";